import { HTMLAttributes } from 'react';
import { joinClassNames } from '../../../utils';
import styles from './styles.module.scss';

export type AccordionTitleProps = HTMLAttributes<HTMLSpanElement> & {
  titleText: string;
  className?: string;
};

export const AccordionTitle = ({ titleText, className, ...props }: AccordionTitleProps) => (
  <span className={joinClassNames(styles.accordionTitle, className)} {...props}>
    {titleText}
  </span>
);

AccordionTitle.displayName = 'AccordionTitle';
